import { NavItem } from './nav-item/nav-item';

export const navItems: NavItem[] = [
  {
    navCap: ' ',
  },
  {
    displayName: 'Dashboard',
    iconName: 'home',
    matIconName: 'home',
    route: '/dashboard',
  },
  {
    displayName: 'PSA',
    iconName: 'bookmark',
    matIconName: 'bookmark',
    route: '/gestione-psa',
  },
  {
    displayName: 'Pratiche',
    iconName: 'box-multiple',
    matIconName: 'description',
    route: '/gestione-psa/lista-submission',
  },
  {
    displayName: 'Staff',
    iconName: 'users-group',
    matIconName: 'account_circle',
    route: '/gestione-psa/anagrafica',
  },
    {
    displayName: 'Filiere',
    iconName: 'map',
   matIconName: 'water',
    route: '/lista-filiere',
  },
    {
    displayName: 'Anagrafiche',
    iconName: 'settings',
   matIconName: 'settings',
    route: '/impostazioni',
  },
  {
    displayName: 'Comunicazioni',
    iconName: 'chat',
    matIconName: 'chat',
    route: '/gestione-psa/lista-comunicazioni',
  },
];
